<template>
  <div style="position: relative">
    <div class="columns">
      <div class="column img-after">
        <img
          src="../assets/images/rdb-logo 3.png"
          alt="nsb-ekyc-logo"
          class="nsb_kyc_logo"
        />
      </div>

    </div>

    <div class="back_arrow" style="color: #d9d9d9" v-if="$root.isFromStatusCheck == 1">
      <b-tooltip label="Status Check" position="is-bottom">
      <img
          src="../assets/images/icons/Blue/Arrow.png"
          alt="Arrow"
          width="40px"
          style="cursor: pointer"
          @click="goStatusCheckPage"
      />
      </b-tooltip>
    </div>

    <div class="Lang_Select" style="color: #d9d9d9">

      <img
        src="../assets/images/icons/black/lang.png"
        alt="Lang_Select.png"
        width="25%"
        height="25%"
        class="mr-1"
      />
      {{ $root.formData.selLang || "En" }}
      <b-dropdown
        aria-role="list"
        v-model="$root.formData.selLang"
        class="ml-1"
      >
        <template #trigger="{}">
          <img style="width: 2rem;" src="../assets/images/icons/Blue/Stroke.png" />
        </template>

        <b-dropdown-item aria-role="listitem" @click="changeLanguage(`en`)"
          >English</b-dropdown-item
        >

        <b-dropdown-item aria-role="listitem" disabled  @click="changeLanguage(`si`)"
          >Sinhala</b-dropdown-item
        >
        <b-dropdown-item aria-role="listitem" disabled @click="changeLanguage(`ta`)"
          >Tamil</b-dropdown-item
        >
      </b-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    changeLanguage(lang) {
      this.$root.selectedLanguage = lang;
      if (lang === "en") {
        this.$root.formData.selLang = "En";
        this.$root.selectedLanguageData = this.$root.engLanguageData;
      } else if (lang === "si") {
        this.$root.formData.selLang = "සිං";
        this.$root.selectedLanguageData = this.$root.sinLanguageData;
      } else if (lang === "ta") {
        this.$root.formData.selLang = "த";
        this.$root.selectedLanguageData = this.$root.tamLanguageData;
      }
    },
    goStatusCheckPage(){

      this.$router.push("enter-name");

    },
  },

};
</script>
<style scoped>
@media (max-width: 500px) {
  .back_arrow{
    position: absolute;
    left: 65%;
    bottom: 2%;
    margin-top: -7.5%;
    height: 71%;
    width: 7%;
  }

}

</style>
